import React from 'react';

const footerLinks = {
  Product: ['Features', 'Pricing', 'Docs', 'Changelog'],
  Developers: ['API Reference', 'SDK', 'Integrations', 'Status'],
  Company: ['Blog', 'About', 'Careers', 'Contact'],
  Legal: ['Privacy', 'Terms', 'Security', 'Cookies'],
};

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-5 gap-8">
          {/* Logo column */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <svg
                viewBox="0 0 32 32"
                className="w-8 h-8"
                fill="none"
                aria-hidden="true"
              >
                <rect width="32" height="32" rx="8" fill="#4F46E5" />
                <circle cx="10" cy="16" r="4" fill="white" opacity="0.9" />
                <circle cx="22" cy="16" r="4" fill="white" opacity="0.9" />
                <circle cx="16" cy="10" r="3" fill="white" opacity="0.7" />
                <circle cx="16" cy="22" r="3" fill="white" opacity="0.7" />
                <line
                  x1="10"
                  y1="16"
                  x2="22"
                  y2="16"
                  stroke="white"
                  strokeWidth="2"
                  opacity="0.6"
                />
                <line
                  x1="16"
                  y1="10"
                  x2="16"
                  y2="22"
                  stroke="white"
                  strokeWidth="2"
                  opacity="0.6"
                />
              </svg>
              <span className="font-semibold text-text-primary">Memory Gateway</span>
            </div>
            <p className="text-text-muted text-sm leading-relaxed mb-6">
              Portable memory for AI agents.
            </p>
            {/* SOC 2 badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-surface-secondary rounded-lg">
              <svg
                viewBox="0 0 20 20"
                className="w-4 h-4 text-primary"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M10 1.944A9.933 9.933 0 016.166 0C3.738.001 1.945 1.794 1.945 4.26c0 1.877.927 3.53 2.365 4.61.32.242.496.679.496 1.13v.12a.75.75 0 01-.75.75h-.154c-.983 0-1.76-.804-1.76-1.77 0-1.19.96-2.15 2.152-2.15 1.068 0 1.908.816 1.908 1.854 0 1.17-.73 2.16-1.814 2.16-.542 0-1.064-.232-1.38-.616l-.054.022c-.39.178-.88.276-1.395.276-.98 0-1.79-.56-2.17-1.33A2.404 2.404 0 000 10.44C0 12.12 1.21 13.5 2.83 13.5h.24c.965 0 1.75-.786 1.75-1.75 0-.59-.29-1.12-.73-1.42-.45-.29-.69-.79-.69-1.3v-.12a.75.75 0 01.75-.75c.414 0 .75.337.75.75v.12c0 .51.24.996.69 1.3.44.3.73.83.73 1.42 0 .964-.785 1.75-1.75 1.75h-.24c-1.62 0-2.83-1.38-2.83-3.06 0-1.29.6-2.46 1.57-3.13.97-.67 2.23-1.03 3.49-1.03.47 0 .92.05 1.36.15l.06-.02c.31-.11.63-.16.97-.16 1.94 0 3.51 1.57 3.51 3.5 0 1.16-.58 2.2-1.47 2.83-.89.63-2.04.98-3.21.98-1.18 0-2.32-.35-3.21-.98A3.494 3.494 0 012.83 11.5c0-1.93 1.57-3.5 3.51-3.5.47 0 .92.05 1.36.15l.06-.02c.31-.11.63-.16.97-.16 1.94 0 3.51 1.57 3.51 3.5 0 1.16-.58 2.2-1.47 2.83-.89.63-2.04.98-3.21.98a4.77 4.77 0 01-3.07-1.12.75.75 0 01-.22-1.04.75.75 0 011.04-.22c.67.57 1.46.98 2.33 1.18v.03a.75.75 0 01-.75.75c-.415 0-.75-.336-.75-.75v-.11c0-.965.785-1.75 1.75-1.75h.24c1.62 0 2.83-1.38 2.83-3.06 0-1.29-.6-2.46-1.57-3.13-.97-.67-2.23-1.03-3.49-1.03-.47 0-.92.05-1.36.15l-.06.02c-.31.11-.63.16-.97.16-1.94 0-3.51-1.57-3.51-3.5 0-1.16.58-2.2 1.47-2.83.89-.63 2.04-.98 3.21-.98.65 0 1.28.12 1.87.33l.05-.02c.38-.14.78-.22 1.2-.22 1.93 0 3.5 1.57 3.5 3.5 0 .69-.21 1.34-.57 1.87l.05.02c.36-.52.56-1.13.56-1.77 0-1.93-1.57-3.5-3.5-3.5a4.44 4.44 0 00-2.01.51.75.75 0 11-.75-1.3c1.15-.6 2.49-.94 3.88-.94 2.76 0 5.07 1.85 5.69 4.38a.75.75 0 01-.14.58.75.75 0 01-.56.26H6.166a.75.75 0 01-.75-.75V1.75c0-.414.337-.75.75-.75h7.068c.197 0 .39.079.53.22a.75.75 0 01-.53 1.28H6.916v7.07c0 .415.337.75.75.75h.15c.197 0 .39.079.53.22a.75.75 0 01-.53 1.28H6.916v1.07c0 .415.337.75.75.75h7.068a.75.75 0 00.53-.22.75.75 0 00-.53-1.28H7.666v-1.07c0-.415.337-.75.75-.75h.15c.197 0 .39.079.53.22a.75.75 0 01-.53 1.28h-1.07c-.414 0-.75.336-.75.75v.15c0 .197.079.39.22.53a.75.75 0 001.28-.53v-.15h1.07c.415 0 .75.336.75.75v7.068c0 .414-.335.75-.75.75H1.944c-.197 0-.39-.079-.53-.22a.75.75 0 01.53-1.28h7.068v-.15c0-.415.337-.75.75-.75h.15c.197 0 .39.079.53.22a.75.75 0 01-.53 1.28H9.916v1.07c0 .415.337.75.75.75h7.068c.197 0 .39.079.53.22a.75.75 0 01-.53 1.28H10.666A9.933 9.933 0 0110 1.944z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-xs font-medium text-text-secondary">SOC 2 Type II</span>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-semibold text-text-primary mb-4">{category}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-text-muted hover:text-primary text-sm transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-text-muted text-sm text-center">
            &copy; 2026 Agent Memory Gateway. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;